import { Box } from '@mui/material';
import { SectionHeaderCellProps } from '../../types';
import { SingleValuePickerV2 } from 'components/SingleValuePicker';

const TotalPersistingSectionCell = ({
  _customRowProps: { day, days, daysHash, onDayChange },
}: SectionHeaderCellProps) => {
  return (
    <Box style={{ float: 'right' }}>
      <SingleValuePickerV2
        item={day}
        items={days}
        itemsHash={daysHash}
        onValueChange={onDayChange}
        inputLabel="Days from now"
        style={{ alignItems: 'center' }}
      />
    </Box>
  );
};

export default TotalPersistingSectionCell;
